import { render, staticRenderFns } from "./Criterion.vue?vue&type=template&id=788bde25&"
import script from "./Criterion.vue?vue&type=script&lang=js&"
export * from "./Criterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports